export enum TimeZone {
  UTC = 'UTC',
  PACIFIC_MIDWAY = 'Pacific/Midway',
  PACIFIC_HONOLULU = 'Pacific/Honolulu',
  AMERICA_ANCHORAGE = 'America/Anchorage',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  AMERICA_DENVER = 'America/Denver',
  AMERICA_CHICAGO = 'America/Chicago',
  AMERICA_NEW_YORK = 'America/New_York',
  AMERICA_SANTIAGO = 'America/Santiago',
  AMERICA_ARGENTINA_BUENOS_AIRES = 'America/Argentina/Buenos_Aires',
  ATLANTIC_AZORES = 'Atlantic/Azores',
  EUROPE_LONDON = 'Europe/London',
  EUROPE_BERLIN = 'Europe/Berlin',
  EUROPE_ATHENS = 'Europe/Athens',
  EUROPE_MOSCOW = 'Europe/Moscow',
  ASIA_DUBAI = 'Asia/Dubai',
  ASIA_KARACHI = 'Asia/Karachi',
  ASIA_DHAKA = 'Asia/Dhaka',
  ASIA_BANGKOK = 'Asia/Bangkok',
  ASIA_SINGAPORE = 'Asia/Singapore',
  ASIA_TOKYO = 'Asia/Tokyo',
  AUSTRALIA_SYDNEY = 'Australia/Sydney',
  PACIFIC_NOUMEA = 'Pacific/Noumea',
  PACIFIC_FIJI = 'Pacific/Fiji',
}

export const timeZoneMapping = {
  UTC: 'UTC',
  GMT: 'Europe/London',
  CET: 'Europe/Berlin',
  CEST: 'Europe/Berlin',
  EET: 'Europe/Athens',
  EEST: 'Europe/Athens',
  MSK: 'Europe/Moscow',
  MSD: 'Europe/Moscow',
  GST: 'Asia/Dubai', // Gulf Standard Time
  PKT: 'Asia/Karachi', // Pakistan Standard Time
  BDT: 'Asia/Dhaka', // Bangladesh Standard Time
  ICT: 'Asia/Bangkok', // Indochina Time
  SGT: 'Asia/Singapore', // Singapore Time
  JST: 'Asia/Tokyo', // Japan Standard Time
  AEDT: 'Australia/Sydney', // Australian Eastern Daylight Time
  AEST: 'Australia/Sydney', // Australian Eastern Standard Time
  NCT: 'Pacific/Noumea', // New Caledonia Time
  FJT: 'Pacific/Fiji', // Fiji Time
  SST: 'Pacific/Midway', // Samoa Standard Time
  HST: 'Pacific/Honolulu', // Hawaii Standard Time
  AKST: 'America/Anchorage', // Alaska Standard Time
  AKDT: 'America/Anchorage', // Alaska Daylight Time
  PST: 'America/Los_Angeles', // Pacific Standard Time
  PDT: 'America/Los_Angeles', // Pacific Daylight Time
  MST: 'America/Denver', // Mountain Standard Time
  MDT: 'America/Denver', // Mountain Daylight Time
  CST: 'America/Chicago', // Central Standard Time
  CDT: 'America/Chicago', // Central Daylight Time
  EST: 'America/New_York', // Eastern Standard Time
  EDT: 'America/New_York', // Eastern Daylight Time
  CLT: 'America/Santiago', // Chile Standard Time
  CLST: 'America/Santiago', // Chile Summer Time
  ART: 'America/Argentina/Buenos_Aires', // Argentina Time
  AZOT: 'Atlantic/Azores', // Azores Standard Time
  AZOST: 'Atlantic/Azores', // Azores Summer Time
  BST: 'Europe/London', // British Summer Time
  WET: 'Europe/Lisbon', // Western European Time
  WEST: 'Europe/Lisbon', // Western European Summer Time
  KST: 'Asia/Seoul', // Korea Standard Time
  HKT: 'Asia/Hong_Kong', // Hong Kong Time
  CT: 'Asia/Shanghai', // China Standard Time
  AWST: 'Australia/Perth', // Australian Western Standard Time
  ACST: 'Australia/Adelaide', // Australian Central Standard Time
  ACDT: 'Australia/Adelaide', // Australian Central Daylight Time
  NZST: 'Pacific/Auckland', // New Zealand Standard Time
  NZDT: 'Pacific/Auckland', // New Zealand Daylight Time
  IST: 'Asia/Kolkata', // India Standard Time
  WIB: 'Asia/Jakarta', // Western Indonesian Time
  WITA: 'Asia/Makassar', // Central Indonesian Time
  WIT: 'Asia/Jayapura', // Eastern Indonesian Time
  CHOST: 'Asia/Choibalsan', // Choibalsan Summer Time
  CHOT: 'Asia/Choibalsan', // Choibalsan Standard Time
  VET: 'America/Caracas', // Venezuela Time
  NST: 'America/St_Johns', // Newfoundland Standard Time
  NDT: 'America/St_Johns', // Newfoundland Daylight Time
  SAST: 'Africa/Johannesburg', // South Africa Standard Time
};
